<template>
  <div>
    <van-popup
      v-model="detailModel"
      position="bottom"
      :style="{ height: '100%',background: '#f5f5f5' }"
    >
      <van-nav-bar fixed>
        <div slot="title">车辆明细</div>
        <div slot="right" @click="closeCur">关闭</div>
      </van-nav-bar>
      <div class="detail-con">
        <van-cell-group>
          <van-cell title="车辆名称编号" v-model="detail.SchoolBusNum" />
          <van-cell title="车牌号" v-model="detail.Registration" />
          <van-cell title="座位数" v-model="detail.Seat" />
          <van-cell title="品牌" v-model="detail.Brand" />
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    detailModel: {
      type: Boolean,
      default: false
    },
    schoolBusID: {
      type: Number,
      default: 0
    }
  },
  name: "schoolBusInfo",
  components: {},
  data() {
    return {
      detail: ""
    };
  },
  created() {
    this.onLoad();
  },
  mounted() {},
  methods: {
    //明细
    async onLoad() {
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SchoolBusSel/GetById`,
        {
          id: this.schoolBusID
        }
      );
      this.loading = false;
      if (res.success) {
        this.detail = res.data;
      }
    },
    //关闭当前弹框
    closeCur() {
      this.$emit("closeDetail");
    }
  },
  watch: {
    schoolBusID: {
      handler(val) {
        if (val) {
          this.schoolBusID = val;
          this.onLoad();
        }
      },
      deep: true
    },
    immediate: true
  }
};
</script>
<style lang="less" scoped>
.detail-con {
  margin-top: 110px;
}
</style>